import { render, staticRenderFns } from "./ChangePassDummyEmail.vue?vue&type=template&id=3163646e&scoped=true&"
import script from "./ChangePassDummyEmail.vue?vue&type=script&lang=js&"
export * from "./ChangePassDummyEmail.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassDummyEmail.vue?vue&type=style&index=0&id=3163646e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163646e",
  null
  
)

export default component.exports